var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.headerText || _vm.$t('modals.confirmDialog.defaultTitle'),"action":_vm.action,"on-submit":_vm.handleConfirm,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"text-gray-700"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }